import React from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { Provider, SvodProvider } from '../../../queries/ats/me/providers/types';
import { SvodSourceIndicator } from '../ats-asset/source-indicator/source-indicator';
import { SvodDeepLink } from '../ats-deep-links/svod-deep-link';
import { AtsItemSharedProps } from './ats-item.interfaces';

interface SvodExternalLinkProps extends AtsItemSharedProps {
  item: Layout.SectionItemLink;
  provider: SvodProvider;
  children: React.ReactNode;
}

export const SvodExternalLink = React.forwardRef<HTMLAnchorElement, SvodExternalLinkProps>(
  ({ item, provider, children, onClick, ...rest }, ref) => {
    return (
      <SvodDeepLink providerIdentifier={item.params.providerIdentifier} providerName={provider.name} onClick={onClick}>
        <a {...rest} href={getLink(provider, item)} onClick={onClick} ref={ref}>
          {children}
          <SvodSourceIndicator provider={provider} masterId={undefined} />
        </a>
      </SvodDeepLink>
    );
  },
);

SvodExternalLink.displayName = 'SvodExternalLink';

function getLink(provider: Provider, item: Layout.SectionItemLink) {
  switch (provider.type) {
    case 'thirdParty':
      return item.params.url;
    case 'svod':
      return item.params.url;
    default:
      return item.params.url;
  }
}
